import { ISSUER_CODE_LIST } from "./payment.constants"

export const parseIssuerCode = (keys: string): string => {
  return ISSUER_CODE_LIST[keys] || keys
}
